import * as React from 'react';

import CoAuthoringBadge16 from './CoAuthoringBadge16';

export const coAuthoringBadge16 = () => <CoAuthoringBadge16 />;

export default {
    title: 'Icon/Line/CoAuthoringBadge16',
    component: CoAuthoringBadge16,
    parameters: {
        notes: "`import CoAuthoringBadge16 from 'box-ui-elements/es/icon/line/CoAuthoringBadge16';`",
    },
};
